/* Copyright (c) 2026 Xperi. All Rights Reserved. */

export enum PlaybackSessionCoordinatorConstants {
  TAG = "PlaybackSessionCoordinator",
  EVENT_NAME = "playbackSession",
  EVENT_NAME_OPERATIONAL_START = "playbackStart",
  EVENT_NAME_OPERATIONAL_END = "playbackEnd",
  MILLISECONDS_PER_SECOND = 1000
}
